var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"alertModal",attrs:{"centered":"","title":_vm.title,"header-bg-variant":_vm.variant,"header-text-variant":"white","size":"xl","ok-only":""}},[_c('p',{staticClass:"my-4"},[_c('ul',_vm._l((_vm.alertMessage),function(item){return _c('li',{key:item},[_vm._v(_vm._s(item))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }